module.exports = __webpack_public_path__ + "img/EXCAVATOR.311a41e5.svg";